import React, { useState, createContext } from 'react';

export const AuthenticatedUserContext = createContext({});

export const AuthenticatedUserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  // Lifted up from RootNavigator so deeply-nested screens (e.g. the
  // hamburger menu's "Sign up" button) can open the Login screen directly,
  // without RootNavigator itself needing to remount.
  const [showLogin, setShowLogin] = useState(false);
  const [loginMode, setLoginMode] = useState('signup');

  const requestLogin = (mode) => {
    setLoginMode(mode || 'signup');
    setShowLogin(true);
  };

  return (
    <AuthenticatedUserContext.Provider value={{ user, setUser, showLogin, setShowLogin, loginMode, setLoginMode, requestLogin }}>
      {children}
    </AuthenticatedUserContext.Provider>
  );
};
